import Localization from 'lib/localization';

export default {
    lxBlockTitle() {
        return Localization.get('badoo_safety_center@navigation.guides.title');
    },

    lxBlockText() {
        return Localization.get('badoo_safety_center@guide.text');
    },

    lxBlockMoreGuidesTitle() {
        return Localization.get('badoo_safety_center@more_guides.title');
    },
};
